import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_4 = { class: "w-full px-2" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_7 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_10 = { class: "text-sm text-red-500 p-error" }
const _hoisted_11 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_12 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_13 = { class: "text-sm text-red-500 p-error" }
const _hoisted_14 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_15 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_20 = { class: "w-full px-2" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_25 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderExpositorSection = _resolveComponent("HeaderExpositorSection")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderExpositorSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "font-bold text-gray-800 mb-0 text-2xl text-center pt-5" }, " ACREDITACIÓN DE EXPOSITORES, CONSTRUCTORES Y PERSONAL DE STAND ", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "text-gray-800 mb-4 text-2xl text-center pt-2 pb-5" }, " Por favor complete el formulario en su totalidad ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block mb-1" }, "Tipo de acreditación", -1)),
                _createVNode(_component_Field, {
                  name: "tipoAcreditado",
                  modelValue: _ctx.formData.tipoAcreditado,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.tipoAcreditado) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione el tipo de acreditación",
                      options: _ctx.tiposAcreditados,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "tipoAcreditado" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Nombre",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Apellido",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block mb-1" }, "DNI / Pasaporte", -1)),
                _createVNode(_component_Field, {
                  name: "documento",
                  modelValue: _ctx.formData.documento,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.documento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "numeric",
                      placeholder: "Documento / Pasaporte",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_ErrorMessage, { name: "documento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block mb-1" }, "Empresa", -1)),
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Empresa",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block mb-1" }, "Mail", -1)),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block mb-1" }, "Empresa para la cual trabaja", -1)),
                _createVNode(_component_Field, {
                  name: "empresaTrabaja",
                  modelValue: _ctx.formData.empresaTrabaja,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.empresaTrabaja) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      filter: "",
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}, "input-base"]),
                      placeholder: "Seleccione la empresa",
                      options: _ctx.empresas
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "empresaTrabaja" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 512), [
              [_vShow, _ctx.formData.tipoAcreditado?.id === 2307]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "submit",
                label: "REGISTRARME",
                class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_24, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_25, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[14] || (_cache[14] = _createTextVNode("REGISTRARME "))
              ], 8, _hoisted_23)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createVNode(_component_FullScreenLoader, {
      visible: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["visible"])
  ], 64))
}